import { useParams } from "react-router-dom";
import CreateUserComponent from "../../components/CreateUserComponent/CreateUserComponent";
import PropTypes from "prop-types";
import CustomAppBar from "../../components/CustomAppBar/CustomAppBar";
import SecureComponent from "../../components/SecApp/SecureComponent";
import { useConfig } from "../../contexts/ConfigContext";

function CreateUserPage({ allowedRoles }) {
  const { config } = useConfig();
  const { tenant } = useParams();
  const theme = `${tenant}-theme`;
  return (
    <>
      <SecureComponent allowedRoles={allowedRoles}>
        <div className={theme} data-testid="theme-name">
          <CustomAppBar className="app-bar " config={config} />
          <CreateUserComponent config={config} />
        </div>
      </SecureComponent>
    </>
  );
}
CreateUserPage.propTypes = {
  config: PropTypes.object,
  allowedRoles: PropTypes.array,
};
export default CreateUserPage;
